<template>
  <section>
    <div class="container clearfix py-5 weps">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-12">
          <h1 class="text-center">Kadının Güçlenmesi Prensipleri (WEPs)</h1>
          <p class="lead text-center">
            7 temel prensip şunlardan oluşmaktadır:
          </p>
          <h3>
            <span>1</span> Toplumsal cinsiyet eşitliği için üst düzey kurumsal
            liderlik sağlanması
          </h3>
          <h3>
            <span>2</span> Tüm kadınlara ve erkeklere iş yaşamında adil
            davarnılması, insan haklarına ve ayrım yapmama ilkesine saygı
            gösterilmesi; bu ilkelerin desteklenmesi
          </h3>
          <h3>
            <span>3</span> Tüm kadın ve erkek çalışanların sağlık, güvenlik ve
            refahının sağlanması
          </h3>
          <h3>
            <span>4</span> Kadınların eğitim, kurs ve profesyonel gelişim
            olanaklarının desteklenmesi
          </h3>
          <h3>
            <span>5</span> Kadınların güçlenmesi için girişimci gelişimi,
            tedarik zinciri ve pazarlama yöntemlerinin uygulanması
          </h3>
          <h3>
            <span>6</span> Toplumsal girişimler ve savunuculuk çalışmalarıyla
            eşitliğin teşvik edilmesi
          </h3>
          <h3>
            <span>7</span> Toplumsal cinsiyet eşitliğine ilişkin elde edilen
            başarıların değerlendirilmesi ve halka açık raporlanması
          </h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$root.$emit("loaded");
  }
};
</script>

<style></style>
